<template>
    <v-row>
        <v-col cols="4" v-for="i in 6" :key="i" class="pb-5">
            <v-card flat>
                <v-card-text>
                    <div
                        class="d-flex align-center justify-center"
                        style="height: 42px"
                    >
                        <v-progress-linear
                            indeterminate
                            color="blew"
                            style="width: 100px !important"
                            rounded
                            height="6"
                        ></v-progress-linear>
                    </div>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "dialog-filter-activity",
    data() {
        return {
            loading: false,
        };
    },

    mounted() {},
};
</script>



// WEBPACK FOOTER //
// LoadingStat.vue?42e9f4a4